.buttonContainer {
    display: flex;
    flex-direction: row-reverse;
}

.fieldContainer {
    margin: 10px 0px;
}